// Types for caregiver app
export interface Shift {
  id: string;
  patient_id: string;
  caregiver_id: string;
  check_in_at: string;
  check_in_photo_url: string;
  check_in_latitude?: number | null;
  check_in_longitude?: number | null;
  check_out_at?: string | null;
  check_out_photo_url?: string | null;
  status: 'active' | 'completed' | 'cancelled';
  notes?: string | null;
  created_at: string;
  // Shift template fields
  shift_template_id?: string | null;
  is_swap?: boolean | null;
  original_template_id?: string | null;
}

export interface TaskExecution {
  id: string;
  task_id: string;
  task_instance_id?: string | null;
  shift_id?: string | null;
  patient_id: string;
  executed_by: string;
  executed_at: string;
  scheduled_for?: string | null;
  photo_url?: string | null;
  notes?: string | null;
  vital_value?: number | null;
  vital_value_secondary?: number | null;
  is_alert?: boolean;
  food_acceptance?: 'nothing' | 'little' | 'half' | 'almost_all' | 'all' | null;
  is_sporadic?: boolean;
  created_at: string;
}

export interface Handoff {
  id: string;
  shift_id: string;
  patient_id: string;
  from_caregiver_id: string;
  to_caregiver_id?: string | null;
  audio_url?: string | null;
  text_summary?: string | null;
  tasks_completed: number;
  tasks_total: number;
  sporadic_meds_given: number;
  incidents_count: number;
  confirmed_at?: string | null;
  created_at: string;
}

// New: Task Instance represents a concrete task for a specific shift/time
export interface TaskInstance {
  id: string;
  shift_id: string;
  task_template_id: string;
  patient_id: string;
  scheduled_for: string;
  status: 'pending' | 'completed' | 'skipped' | 'late';
  execution_id?: string | null;
  created_at: string;
  // Joined data
  task_template?: {
    id: string;
    name: string;
    task_type: string;
    vital_type?: string | null;
    unit?: string | null;
    dose?: string | null;
    dose_unit?: string | null;
    administration_route?: string | null;
    photo_required?: boolean;
    min_alert_value?: number | null;
    max_alert_value?: number | null;
    food_type?: string | null;
    hygiene_type?: string | null;
    description?: string | null;
  };
  execution?: TaskExecution | null;
}

export type FoodAcceptance = 'nothing' | 'little' | 'half' | 'almost_all' | 'all';

export const FOOD_ACCEPTANCE_LABELS: Record<FoodAcceptance, string> = {
  nothing: 'Nada',
  little: 'Pouco',
  half: 'Metade',
  almost_all: 'Quase Tudo',
  all: 'Tudo'
};
